import store from './store';

class Auth {
  // 进入登录页面
  redirectLoginPage() {
    window.location.href = `${store.loginUrl}?redirect_url=${encodeURIComponent(
      window.location.href
    )}&loginTitle=${store.loginTitle}`;
  }

  // 检查登录状态
  checkLoginStatus() {
    this.redirectLoginPage();
  }

  // 支付宝授权登录
  alipayAuth() {}

  // 微信授权登录
  wechatAuth() {}

  // 哈啰APP授权登录
  helloAuth() {}
}

export default new Auth();
